import React, { useContext, useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import ApplicationContext from "../../context/index";
import AcknowledgeForm from "./indexForm";
import useApi from "../../hooks/useApi";
import { Box } from "@material-ui/core";
import { useStyles } from "./styles";
import { scrollTop } from "../../helpers/utils";
import { useHistory, useParams } from "react-router";
import { getApplicationRoute, navigateToUrl } from "../../helpers/utils";
import { ReducerUtils } from "../../constants/reducers";

function Acknowledge({ classes: { loaderBox } }) {
  const { claim } = useParams();
  const { state, dispatch } = useContext(ApplicationContext);
  const orderDetails = useApi(`partners/claim/${claim}`);
  const history = useHistory();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => scrollTop(), []);
  useEffect(() => {
    if (orderDetails) {
      dispatchEvent(ReducerUtils.order.details, orderDetails);
      setIsLoaded(true);
    }
  }, [orderDetails]);

  const clickHandler = () =>
    navigateToUrl(getApplicationRoute("dashboard"), history);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  return isLoaded ? (
    <AcknowledgeForm clickHandler={clickHandler} />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Acknowledge);
